import {Action} from 'redux'
import {FeedbackFormModel} from '../Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialFeedbackFormDetailState: IFeedbackFormDetailState = {
  data: {
    feedbackForm: [],
    meta: [],
  },
  loading: false,
  success: false,
  deleteSuccess: false,
}

export interface IFeedbackFormDetailState {
  data?: {
    feedbackForm?: FeedbackFormModel[]
    meta?: {[key: string]: string | number}[]
  }

  loading?: boolean
  success?: boolean
  deleteSuccess?: boolean
}

export const reducer = (
  state: IFeedbackFormDetailState = initialFeedbackFormDetailState,
  action: ActionWithPayload<IFeedbackFormDetailState>
) => {
  switch (action.type) {
    case actionTypes.GET_FEEDBACK_FORM_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_FEEDBACK_FORM_DETAIL_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_FEEDBACK_FORM_DETAIL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.EXPORT_FEEDBACK_FORM_DETAIL_FILE_START: {
      return {...state, loading: true}
    }

    case actionTypes.EXPORT_FEEDBACK_FORM_DETAIL_FILE_SUCCESS: {
      return {...state, success: true, loading: false}
    }

    case actionTypes.EXPORT_FEEDBACK_FORM_DETAIL_FILE_FINISH: {
      const error = action.payload
      return {...state, error, success: false, loading: false}
    }

    //Delete
    case actionTypes.DELETE_FEEDBACK_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_FEEDBACK_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_FEEDBACK_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    default:
      return state
  }
}
